import { useEffect, useState } from "react";
import firebase from "firebase";

// The superuser privilege is a Firebase custom claim, not a comparison against
// a hardcoded email address, so nothing here identifies the admin account and
// the privilege can be moved or revoked without a release. The claim in the ID
// token is what the functions and the Firestore rules check; the checks below
// only decide which controls to render.
export const SUPER_ADMIN_CLAIM = "superAdmin";

// Firebase restores the signed-in user asynchronously after a reload, so the
// claim is not readable during the first render. Components subscribe and
// re-render when it lands. Returns the unsubscribe function.
export const watchSuperAdminClaim = (onChange) =>
  firebase.auth().onIdTokenChanged(async (user) => {
    if (!user) {
      onChange(false);
      return;
    }
    try {
      const idTokenResult = await user.getIdTokenResult();
      onChange(idTokenResult.claims[SUPER_ADMIN_CLAIM] === true);
    } catch (err) {
      onChange(false);
    }
  });

export const useSuperAdmin = () => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  useEffect(() => watchSuperAdminClaim(setIsSuperAdmin), []);
  return isSuperAdmin;
};
